module.exports = __webpack_public_path__ + "img/retail_store.156b4e19.png";